export class Timezone {
    mstimeZoneId: string;
    dst: boolean;
    timeZone: string;
    gmtoffset: number;
    id: number;
}


export class State {
    state: string;
    statecode: string;
}


export class Country {
    countryId: string;
    countryName: string;
}


export class EmrVendor {
    emrvendorId: string;
    code: string;
    name: string;
    isActive: string;
}

export class Offering {
    offeringId: string;
    name: string;
}


export class ChangePassword {
    OldPassword: string;
    newPassword: string;
    confirmPassword: string;
}


export class EmailReportTypes {
    reportTypeId: string;
    reportname: string;
    selectedFacilities: any[];
    isDisabled: boolean;
    frequency: any;
}


export class PasswordVars {
    minPasswordLength: number;
    maxPasswordLength: number;
    isMixedCaseRequired: boolean;
    minNumericCharacters: number;
    minSpecialCharacters: number;
    passwordValidationExpression: string;
}


export class MessageType {
    messageTypeId: string;
    name: string;
    sort: number;
}


export class NotificationType {
    alertTypeId: string;
    name: string;
   
}


export class ScheduleNotification {
    notificationType: string;
    subscriberId: string;
    subscriberFullName:string;
    subscribedUsers: any;
    subscriberFacilityIds: any;
    subscriberFacilityNames: any;
    subscriberGroupIds: any;
    subscriberPatientIds: any;
    fromDate: Date;
    toDate: Date;
    fromTime: string;
    toTime: string;
    is24By7: boolean;
    messageTypeIds: any;
    messageTypeNames: any;
    isRecurrence: boolean;
    recurringDays: any;
    notificationOptions: any;
    sentToEmail: any;
    sentToPhone: any;
    sentToText: any;
    isDeleted: boolean;
    isActive: boolean;
    pin: any;
}

export class BreachNote {
    firstName: string;
    middleName: string;
    lastName: string;
    facility: string;
    message: string;
    breachId: string;
    facilityTimeZoneId: string;
    reading: any;
}


export class ResourceCategory {
    resourceCategoryId: string;
    categoryName: string;
    description: string;
    createdOn: Date;
    createdBy: string;
    lastModifiedOn: Date;
    lastModifiedBy: string;
    resource: any;
}

export class Resource {
    resourceId: string;
    resourceCategoryId: string;
    resourceCategoryName: string;
    title: string;
    resourceContent: string;
    url: string;
    embed: string;
    createdOn: Date;
    createdBy :string;
    lastModifiedOn: Date;
    lastModifiedBy: string;
    expiresOn: Date;
    isActive: boolean;
}




export class UserSearchParams {
    facilityNames: string[];
    roleNames: string[];
    userName: string;
    firstName: string;
    lastName: string;
    isActive: boolean;
    globalSearchString: string;
}

export class CaptureApplicationMessage {
    title: string;
    message: string;
    messageCategory: any;
    blockApplication: boolean;
    messageAppearOn: any;
    messageDisappearOn: any;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/general.ts